import { Component, OnInit } from '@angular/core';
import { PhaseService } from '../_services/phase.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-phase-select',
	templateUrl: './phase-select.component.html',
})
export class PhaseSelectComponent implements OnInit {
	constructor(public phaseService: PhaseService) {}
	phases: any;
	subscriptions: Subscription[] = [];
	ngOnInit(): void {
		this.subscriptions.push(
			this.phaseService.phases$.subscribe((data) => {
				this.phases = data;
				if (localStorage.getItem('selectedPhase')) {
					this.phaseService.setPhase(
						JSON.parse(localStorage.getItem('selectedPhase')),
					);
				} else {
					this.phaseService.setPhase(data[0]);
				}
			}),
		);
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
